import type { ServiceTileFragment } from '@/lib/types/datocms/graphql/generated'
import { TextWithHighlight } from '../TextWithHighlight'
import CtaTransparent from '../ui/cta/CtaTransparent'
import Eyebrow from '../ui/Eyebrow'
import { isStructuredTextEmpty } from '@/utils/datocms/isStructuredTextEmpty'

export default function ServiceTileSection({ title, tag, items }: Readonly<ServiceTileFragment>) {
	return (
		<section className="service-tile-section @container">
			<div className="common-x-padding max-w-screen-2xl mx-auto py-10 @lg:py-20">
				{tag && <Eyebrow>{tag}</Eyebrow>}
				{title && !isStructuredTextEmpty(title.text) && (
					<div className="heading-size-3 mt-4 lg:mt-10">
						<TextWithHighlight text={title} />
					</div>
				)}

				<div className="grid grid-cols-1 @5xl:grid-cols-2 gap-5 mt-12 lg:mt-20">
					{items.map((item, idx) => (
						<div
							key={item.id as string}
							className="group bg-white-frosted hover:bg-white-frosted-shade rounded-xl cursor-pointer transition-colors duration-300 ease-out @container"
						>
							<div className="flex flex-col h-full px-4 @md:px-12 py-6 @md:py-8">
								<span className="font-mono text-blue text-sm">
									{idx < 10 && '0'}
									{idx + 1}.
								</span>
								{item.title && <h3 className="text-2xl font-semibold mt-6">{item.title}</h3>}
								{item.description && <p className="mt-3">{item.description}</p>}
								{item.link && (
									<div className="mt-auto ml-auto">
										<CtaTransparent variant="tertiary" cta={item.link} className="mt-10" />
									</div>
								)}
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	)
}
